import React from 'react';

export default function DownloadOutlineIcon({
  width = '21',
  height = '21',
  fill = 'black',
  ...props
}: React.ComponentProps<'svg'>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 13.5691L6.94233 10.0115L7.82052 9.10765L9.875 11.1621V4.16211H11.125V11.1621L13.1794 9.10765L14.0576 10.0115L10.5 13.5691ZM5.75642 16.6621C5.33547 16.6621 4.97917 16.5162 4.6875 16.2246C4.39583 15.9329 4.25 15.5766 4.25 15.1557V12.8961H5.49998V15.1557C5.49998 15.2198 5.52669 15.2785 5.5801 15.332C5.63353 15.3854 5.69231 15.4121 5.75642 15.4121H15.2435C15.3077 15.4121 15.3664 15.3854 15.4199 15.332C15.4733 15.2785 15.5 15.2198 15.5 15.1557V12.8961H16.75V15.1557C16.75 15.5766 16.6041 15.9329 16.3125 16.2246C16.0208 16.5162 15.6645 16.6621 15.2435 16.6621H5.75642Z"
        fill={fill}
      />
    </svg>
  );
}
